import { render, staticRenderFns } from "./RoleuserAdd.vue?vue&type=template&id=6918b5da&scoped=true&"
import script from "./RoleuserAdd.vue?vue&type=script&lang=js&"
export * from "./RoleuserAdd.vue?vue&type=script&lang=js&"
import style0 from "./RoleuserAdd.vue?vue&type=style&index=0&id=6918b5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918b5da",
  null
  
)

export default component.exports